import CLSLogger from '@tencent/nb-cls-logger';

function getCookie(key) {
  const { cookie } = document;

  console.log('cookie: ');
  console.log(cookie);

  const m = cookie.match(new RegExp(`(^| |;)${key}=([^;]*)(;|$)`));
  console.log(!m ? '' : decodeURIComponent(m[2]));
  return !m ? '' : decodeURIComponent(m[2]);
}

const Logger = new CLSLogger({
  env: process.env.ENV === 'prod' ? 'formal' : 'test',
  uid: getCookie('UID') || '',
  platform: 'H5',
  name: 'h5-image',
});

Logger.sendLogicInfo = function (model = '', msg = '', args = {}) {
  const page = window.location.href;
  this.uplogNow('INFO', msg, {
    logType: 'logic',
    model,
    page,
    args: {
      Page: page,
      sdkName: 'nb-h5-image',
      ...args,
    },
  });
};

export default Logger;
